import React, { useState, useEffect } from 'react'
import Menu from '../MainMenu'
import PropTypes from 'prop-types'
import './Layout.scss'
import Footer from '../Footer/Footer'
import bgImage from '../../../addons/images/bg-image.png'
import PathMenu from '../PathMenu/PathMenu'
import HamburgerMenu from '../HamburgerMenu'
import { Transition, Responsive } from 'semantic-ui-react'
import Notifications from 'react-notification-system-redux'

var styles = {
  backgroundImage: `url(${bgImage})`,
  backgroundSize: '100%',
  backgroundRepeat: 'no-repeat'
}

const layout = (props) => {
  const [menuToggle, toggle] = useState(false)
  const [transition, setTransition] = useState(false)

  useEffect(() => {
    setTimeout(() => setTransition(true))
  }, [])

  let pathMenu = null
  !props.isMain && props.link && (pathMenu = <PathMenu link={props.link}/>)

  return (
    <div>
      <Responsive maxWidth={1200}>
        <HamburgerMenu toggle={toggle} menuToggle={menuToggle}>
          <Transition visible={transition} animation='scale' duration={500}>
            <div className='layout' style={props.isMain && styles}>
              <div className='layoutBody'>
                {pathMenu}
                {props.children}
              </div>
              <Notifications notifications={props.notifications} />
              <Footer />
            </div>
          </Transition>
        </HamburgerMenu>
      </Responsive>
      <Responsive minWidth={1200}>
        <div className='layout' style={props.isMain && styles}>
          <Menu main={props.isMain} />
          <Transition.Group animation='fade' duration='400'>
            {transition && <div>
              <div className='layoutBody'>
                {pathMenu}
                {props.children}
              </div>
              <Notifications notifications={props.notifications} />
              <Footer />
            </div>}
          </Transition.Group>
        </div>
      </Responsive>
    </div>
  )
}

layout.propTypes = {
  isMain: PropTypes.bool,
  children: PropTypes.any,
  link: PropTypes.array,
  notifications: PropTypes.any
}

export default layout



// WEBPACK FOOTER //
// ./src/layouts/Layout/components/Layout.js